module.exports = __webpack_public_path__ + "static/Terms_and_Conditions-412eb9b7ba32f714e38327a6f70cd2c5.pdf";